import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import Header from "../Components/Header/Header";
import Sidebar from "../Components/Sidebar/Sidebar";
import { getInvoicesWithUserData } from "../Api/bookingApi";
import { API_URL } from "../Api/config";
import { Roller } from "react-awesome-spinners";
import paginationFactory from "react-bootstrap-table2-paginator";

function InvoiceReport() {


    const columns = [
        {
            dataField: "id",
            text: "ID",
            sort: true,
        },
        {
            dataField: "first_name",
            text: "First Name",
            sort: true,
        },
        {
            dataField: "last_name",
            text: "Last name",
            sort: true,
        }, {
            dataField: "user_email",
            text: "User Email",
            sort: true,
        }, {
            dataField: "invoice_id",
            text: "Invoice Id",
            sort: true,
        }, {
            dataField: "total",
            text: "Total",
            sort: true,
        }, {
            dataField: "status",
            text: "Status",
            sort: true,
        },
    ];

    const [invoicedata, setInvoicedata] = useState([]);
    const [loading, setLoading] = useState(false)

    const [totalSize, setTotalSize] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);

    useEffect(() => {
        getinvoiceData(page, perPage);
    }, []);

    const getinvoiceData = (page = 1, perPage = 10) => {
        setLoading(true);
        const formData = new FormData();
        formData.append("page", page);
        formData.append("perPage", perPage);
        getInvoicesWithUserData(formData)
            .then((res) => {
                if (res.code === 200) {
                    const ApiResponse = res.data;
                    setInvoicedata(ApiResponse.data);
                    setTotalSize(ApiResponse.total);
                } else {
                    console.log("Something went wrong");
                }
            })
            .catch((error) => {
                console.log(error);
            }).finally(() => {
                setLoading(false);
            })
    }

    const handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
        getinvoiceData(page, sizePerPage);
        setPage(page);
        setPerPage(sizePerPage);
    };



    return (
        <>

            {
                loading ? (
                    <div className="loading">
                        <Roller />
                    </div>
                ) : (<>
                    <div className="dashboard-container d-flex">
                        <div className="sidebar-container">
                            <Sidebar />
                        </div>
                        <div className="main-container">
                            <div className="main-page-body-content">
                                <div className="main-page-body-content-body">
                                    <div className="main-page-body-content-body-container">
                                        <div className="pd-26">
                                            <div className="table-card">
                                                <div className="card-body table-card-body">
                                                    <div className="table-card-header mb-4 d-flex justify-content-between">
                                                        <h5 className="card-title">Invoice Report</h5>
                                                        <div className="d-flex justify-content-end">
                                                            <div className="export-btn"></div>
                                                        </div>
                                                    </div>
                                                    <div className="table-card-body-inner">
                                                        <div className="animated fadeIn">
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div className="card">
                                                                        <div className="card-header d-flex table-card-header"></div>
                                                                        <div className="card-body">
                                                                            <BootstrapTable
                                                                                keyField="id"
                                                                                data={invoicedata}
                                                                                columns={columns}
                                                                                striped
                                                                                hover
                                                                                condensed
                                                                                bootstrap4
                                                                                pagination={paginationFactory({
                                                                                    page,
                                                                                    sizePerPage: perPage,
                                                                                    totalSize: totalSize,
                                                                                    onPageChange: (p) => setPage(p),
                                                                                    onSizePerPageChange: (size, p) => {
                                                                                        setPerPage(size);
                                                                                        setPage(1);
                                                                                    },
                                                                                    showTotal: true,
                                                                                    sizePerPageList: [
                                                                                        { text: '10', value: 10 },
                                                                                        { text: '25', value: 25 },
                                                                                        { text: '50', value: 50 },
                                                                                    ],
                                                                                })}
                                                                                onTableChange={handleTableChange}
                                                                                noDataIndication={loading ? "Loading..." : "No records found"}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                )
            }
        </>
    );
}

export default InvoiceReport;
